import { BaseModel } from '@nuxtDatakodeUtils/models/BaseModel'

type OpportunityData = PildomModules.Voirie.Data.OpportunityData

export class Comment extends BaseModel<any> { // TODO add CommentData type
    endPoint: string = 'voirie/opportunities/{opportunity}/comments'
    translationKey: string = 'voirie.comments'
    permissionName: string = 'voirie_comment'
    public opportunity: OpportunityData

    setOpportunity(opportunityData: OpportunityData): Like {
        this.opportunity = opportunityData
        return this
    }

    getEndPoint(useEntityId: boolean = false): string {
        const baseEndPoint = this.endPoint.replace('{opportunity}', this.opportunity.id)
        if (useEntityId)
            return `${baseEndPoint}/${this.getKey()}`
        return baseEndPoint
    }
}
